var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('StudioTopbar',{attrs:{"transparent":false}}),_vm._v(" "),_c('v-main',{staticClass:"grey lighten-4"},[_c('nuxt')],1),_vm._v(" "),_c('NewVersionAlert'),_vm._v(" "),_c('Snackbar'),_vm._v(" "),_c('ThePaywall'),_vm._v(" "),_c('TheDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }